











import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class UnsavedChanges extends Vue {
  @Prop() private readonly disabled?: boolean
}
